import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { workOrderBaseProperties } from "src/db/collectionDefinitions/csi/workOrder"
import { ItemWorkOrder } from "src/util/types/dataModels/item"

//region Types

export type ItemWorkOrderDocument = RxDocument<ItemWorkOrder>
export type ItemWorkOrderCollection = RxCollection<ItemWorkOrder>

//endregion

/**
 * Schema for item work orders
 */
export const itemWorkOrderSchema: RxJsonSchema<ItemWorkOrder> = {
  title: "Item Work Order schema",
  description: "Collection of all work orders for an item",
  version: 0,
  primaryKey: "item_id",
  type: "object",
  keyCompression: true,
  properties: {
    item_id: { type: "string", maxLength: 36, uniqueItems: true },
    work_orders: {
      type: "array",
      items: {
        type: "object",
        properties: {
          ...workOrderBaseProperties,
          // These are the Items which belong to the above work order
          items: {
            type: "array",
            items: {
              type: "string",
            },
          },
        },
      },
    },
  },
  required: ["item_id", "work_orders"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const itemWorkOrderCollectionCreator: RxCollectionCreator = {
  schema: itemWorkOrderSchema,
}
